module.exports = __webpack_public_path__ + "4be23897b7f025df4923cb964c93ab1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-18.jpg
// module id = 1158
// module chunks = 0